import { useQuery } from '@tanstack/react-query';
import { getImageAnalysisStatus, ImageAnalysisStatusResponse } from 'api/jobs';
import { JobStatus } from 'interfaces/job';

const IDLE_STATUS_REFRESH_MS = 15000;
const ACTIVE_STATUS_REFRESH_MS = 5000;

const hasPendingOrRunningStatus = (data?: ImageAnalysisStatusResponse) =>
  Boolean(data?.statuses?.some((status) => status.status === JobStatus.Pending || status.status === JobStatus.Running));

export const useImageAnalysisStatus = ({
  studyId,
  slideIds,
  labId,
  enabled,
}: {
  studyId: string;
  slideIds: string[];
  labId: string;
  enabled: boolean;
}) =>
  useQuery({
    queryKey: ['imageAnalysisStatus', studyId, labId, slideIds],
    queryFn: ({ signal }) => getImageAnalysisStatus({ studyId, slideIds, labId }, signal),
    enabled,
    // Keep the last status visible while this refetches. Pending and running jobs poll faster.
    refetchInterval: (data) => (hasPendingOrRunningStatus(data) ? ACTIVE_STATUS_REFRESH_MS : IDLE_STATUS_REFRESH_MS),
  });
